module.exports = __webpack_public_path__ + "static/texture-3aa0114e853fa197549d0adf6b813623.png";